import React, { useState } from 'react';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaPhone, FaEnvelope, FaCheck, FaBars, FaTimes } from 'react-icons/fa';
import './Header.css';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(prevState => !prevState);
  };
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/'); // Redirect to the home page
  };
  const handleReserveClick = () => {
    navigate('/reserving'); // Redirect to the home page
  };
  const handleBookClick = () => {
    const selectRoomElement = document.getElementById('select-room');
    
    if (selectRoomElement) {
      // Scroll to the element with id 'select-room'
      selectRoomElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',  // Aligns to the top of the element
      });
    }
  };
  return (
    <header>
      {/* Top Header */}
      <div className="top-header">
        <div className="social-icons">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
            <FaFacebook />
          </a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
            <FaTwitter />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
            <FaInstagram />
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
            <FaLinkedin />
          </a>
        </div>
        
        <div className="contact-info">
          
          <p><FaPhone /> 0175 476 5119</p>
          <p><FaEnvelope /> info@moonsidehotel.co.uk</p>
        </div>

        <div className="top-buttons">
          <button className="cta-button" onClick={handleBookClick}><FaCheck /> Book a Room</button>
          <button className="cta-button bbb" onClick={handleReserveClick}><FaCheck /> Reserve Table</button>
          <button className="cta-button"><FaCheck /> Gift Vouchers</button>
        </div>
      </div>

      {/* Main Header */}
      <div className="main-header">
        <div className="logo" onClick={handleLogoClick}>
          <img src='/Assets/ewe.png' width={180}></img>
        </div>

        {/* Hamburger Menu Icon */}
        <div className="hamburger" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        <nav className={`navigation ${menuOpen ? 'active' : ''}`}>
          <ul>
            <li><a href="\">Home</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#findus">How To Find Us</a></li>
            <li><a href="#events">Events & Offers</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
